import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { getAlertRuleList } from "api/alertAPI";
import { baseQueryInfo, useQueryKey } from "utils/queryUtil";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "./useStompDebouncedRefetch";

export interface UseKeyTableProps {
  queryInfo?: BasePagination;
  options?: any;
}

export function useAlertRules({
  queryInfo = baseQueryInfo,
  options,
}: UseKeyTableProps) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const queryKey = useQueryKey(queryInfo);

  const alertRuleQuery = useQuery(
    ["alertRule", queryKey, selectedAccount.accountId],
    () =>
      getAlertRuleList({
        accountId: selectedAccount.accountId,
        payload: queryInfo,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
      ...(options ?? {}),
    }
  );
  useStompDebouncedRefetch({
    stompKey: ["alertRuleListUpdated"] as StompDateSignalKey[],
    refetch: alertRuleQuery.refetch,
  });

  const hasAlertRuleList: boolean = useMemo(() => {
    if (
      !alertRuleQuery.isLoading &&
      alertRuleQuery.data?.error === 0 &&
      alertRuleQuery.data.result?.length > 0
    ) {
      return true;
    }
    return false;
  }, [alertRuleQuery.data]);

  return { hasAlertRuleList, alertRuleQuery };
}
